import { render, staticRenderFns } from "./academy-list-page.vue?vue&type=template&id=4c98d5c5&"
import script from "./academy-list-page.vue?vue&type=script&lang=js&"
export * from "./academy-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports